import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { ChargingStationDeclarationState } from './types';

export const getters: GetterTree<ChargingStationDeclarationState, RootState> = {}
